var fn = function( obj ){
var __t,__p='';
__p+='#if __VERSION__ == 300\n    #define IN in\n    #define OUT out\n#else\n    #define IN attribute\n    #define OUT varying\n#endif\n\nuniform sampler2D uParticleTex;\n\nOUT float vAlpha;\nOUT float vColor;\n\nvoid main(void){\n    vec4 particle = texture2D(uParticleTex, gl_PointCoord);\n    vec3 col = COLOR1;\n    if(vColor > 1.) col = COLOR2;\n    if(vColor > 2.) col = COLOR3;\n    gl_FragColor.rgb = vec3(1., 1., 1.) * particle.rgb * col;\n    gl_FragColor.a = (.2 + (vAlpha) * 0.5) * particle.a;\n//   gl_FragColor.a = 1.;\n}\n';
return __p;
};
fn.toString=fn;
module.exports = fn;